import PropTypes from 'prop-types';
import React from 'react';
import BriefStore from 'contest/stores/brief-store';
import { connectToStores } from 'fluxible-addons-react';
import withExpandedUI from 'contest/components/expanded-ui';
import BriefApp from 'contest/components/brief/app';

class BriefAppWrapper extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.outline !== nextProps.outline ||
            this.props.isExpandedUI !== nextProps.isExpandedUI
        );
    }

    render() {
        return <BriefApp {...this.props} />;
    }
}

BriefAppWrapper.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

BriefAppWrapper.propTypes = {
    outline: PropTypes.object.isRequired,
    isExpandedUI: PropTypes.bool.isRequired,
};

const ConnectedBriefApp = connectToStores(
    withExpandedUI(BriefAppWrapper),
    [BriefStore],
    (context, props) => {
        const store = context.getStore(BriefStore);
        return {
            listingId: store.listingId,
            outline: store.outline,
            changes: store.changes,
            score: store.score,
            editMode: store.isEditable,
            translationMode: store.isTranslatable,
            selectedLanguageKey: store.selectedLanguageKey,
            deliverables: store.deliverables,
            fileTypes: store.fileTypes,
            createBriefFileUrl: store.createBriefFileUrl,
        };
    }
);

export default ConnectedBriefApp;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/connected/connected-brief-app.jsx